/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Loader from '/client/src/components/Loader';
import { DELETE, POST, GET } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import EventPageSponsorSearchbar from './searchbar';
import EventPageDetailSponsorBody from './body';
import ModalCreateSponsor from './modalCreateSponsor';

import './styles.scss';

type PropsType = {
  match: {
    params: {
      tableTab?: string,
      eventId: number | string
    }
  }
};

const items = [
  {
    link: 'sponsor',
    label: 'Sponsors'
  }
];

const EventPageDetailSponsor = ({ match }: PropsType): React.Element<'div'> => {
  const { params: { eventId } } = match;
  const sponsorListApiUrl = `/api/v1/1/sponsors/event/${eventId}`;
  const [isOpenModal, handleToggleModal] = React.useState(false);
  const [sponsors, setSponsors] = React.useState([]);
  const [sponsorsGlobal, setGlobalSponsors] = React.useState([]);
  const [selectedRows, handleSelectRow] = React.useState([]);
  const [isPending, setIsPending] = React.useState(false);
  const [isPendingGlobalSponsors, setIsPendingGlobalSponsors] = React.useState(false);

  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`EventPageDetailSponsor-menuItems-${k}`}
        className='active'
      >
        <Link to={`/events/${eventId}/manage/${i.link}`}>
          {i.label}
        </Link>
      </li>
    );
  });

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          setSponsors(_.get(response, 'data.result', []));
        } catch (e) {
          console.error('cant get sponsor list');
        }
      }
    },
    []
  );

  const handleUpdateSponsor = async (): any => {
    try {
      const { result } = await GET(sponsorListApiUrl);

      setSponsors(result);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCreateSponsor = async (sponsorsEmail: [], sponsorName: string): any => {
    CssPinner(document.querySelector('.modal-sponsor-create'), true);
    setIsPending(true);

    try {
      await POST(`/api/v1/1/sponsors/create/${eventId}/users`, {
        emails: sponsorsEmail,
        name: sponsorName
      }).then((response: any) => {
        if (!!response.success) handleUpdateSponsor();
      }).then(() => {
        CssPinner(document.querySelector('.modal-sponsor-create'), false);
        handleToggleModal(false);
        setIsPending(false);
      });
    } catch (e) {
      console.log(e);
      setIsPending(false);
      CssPinner(document.querySelector('.modal-sponsor-create'), false);
    }
  };

  const handleRemoveSponsor = async (): any => {
    if (!_.size(selectedRows)) {
      return;
    }

    CssPinner(document.querySelector('.EventDetailContainer .panel-body'), true);

    const removedIds = _.map(selectedRows, (sr: {}): number => sr.id);

    try {
      await DELETE(sponsorListApiUrl, {
        ids: removedIds
      }).then((response: any) => {
        console.log('response', !!response.success);
        if (!!response.success) handleUpdateSponsor();
      });

      handleSelectRow([]);

      CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
    } catch (e) {
      CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
    }
  };

  const handleAddSponsor = async (rows: []): any => {
    CssPinner(document.querySelector('.EventPageSponsorModal'), true);
    setIsPending(true);

    const toAddIds = _.map(rows, (sr: {}): number => sr.id);

    try {
      await POST(sponsorListApiUrl, {
        sponsor_ids: toAddIds
      }).then(() => {
        CssPinner(document.querySelector('.EventPageSponsorModal'), false);
        handleUpdateSponsor();
        handleToggleModal(false);
        setIsPending(false);
      });
    } catch (e) {
      CssPinner(document.querySelector('.EventPageSponsorModal'), false);
    }
  };

  const getGlobalSponsors = async (): any => {
    const isPendingGlobalSponsors = (status: boolean): void => {
      CssPinner(document.querySelector('.modal-sponsor-create'), status);
      setIsPending(status);
      setIsPendingGlobalSponsors(status);
    };

    isPendingGlobalSponsors(true);

    try {
      const { result } = await GET(`/api/v1/1/sponsors/event/${eventId}/attach`);

      setGlobalSponsors(result);

      isPendingGlobalSponsors(false);
    } catch (e) {
      console.log(e);
      isPendingGlobalSponsors(true);
    }
  };

  return (
    <div className="panel panel-default EventPageDetailSponsor">
      <div className="navbar-page-toolbar send-mail-navbar panel-heading-color3">
        <div className="container-fluid" style={{ height: '50px' }}>
          <ul className="nav top-nav">
            {menuItems}
          </ul>

          <ul className="nav">
            <li className="dropdown hide show-520">
              <a href="#"
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="icon icon-bars" />
              </a>
              <ul className="dropdown-menu">
                {menuItems}
              </ul>
            </li>
          </ul>
        </div>

        <EventPageSponsorSearchbar
          eventId={eventId}
          handleShowModal={handleToggleModal}
          selectedRows={selectedRows}
          handleRemoveSponsor={handleRemoveSponsor}
          isEmptyList={!_.size(sponsors)}
          isEmptySelectedItems={!_.size(selectedRows)}
          getGlobalSponsors={getGlobalSponsors}
        />
      </div>

      <Loader
        url={sponsorListApiUrl}
        onLoaded={handleLoaded}
      >
        {!!_.size(sponsors) ?
          <EventPageDetailSponsorBody
            sponsors={sponsors}
            handleSelectRow={(tableState: {}) => {
              handleSelectRow(tableState.selectedRows);
            }}
            eventId={eventId}
          /> :
          <div className="text-center" style={{ margin: '3em 0' }}>You don't have sponsors now.</div>
        }
      </Loader>

      {isOpenModal &&
        <ModalCreateSponsor
          eventId={eventId}
          isOpen={isOpenModal}
          isPending={isPending}
          handleClose={(): void => handleToggleModal(false)}
          handleCreateSponsor={handleCreateSponsor}
          getGlobalSponsors={getGlobalSponsors}
          sponsorsGlobal={sponsorsGlobal}
          isPendingGlobalSponsors={isPendingGlobalSponsors}
          handleAddSponsor={handleAddSponsor}
        />
      }
    </div>
  );
};

export default withRouter(EventPageDetailSponsor);
